export interface IMembershipType {
  id: number | null;
  programId?: number | null;
  name?: string | null;
  displayName?: string | null;
  active?: boolean | null;
  duration?: number | null;
  expirationType?: string | null;
  price?: number | null;
  oldDiscountType?: number | null;
  gcEligible?: boolean | null;
  availableOnline?: boolean | null;
  haveGuest?: boolean | null;
  gcRegCodeRowId?: number | null;
  ratingsRestricted?: boolean | null;
  taxable?: boolean | null;
  renewalEligible?: boolean | null;
  displayOrder: number | null;
}

export class MembershipType implements IMembershipType {
  id;
  programId;
  name;
  displayName;
  active;
  duration;
  expirationType;
  price;
  oldDiscountType;
  gcEligible;
  availableOnline;
  haveGuest;
  gcRegCodeRowId;
  ratingsRestricted;
  taxable;
  renewalEligible;
  displayOrder;

  constructor(config: IMembershipType) {
    this.id = config.id;
    this.programId = config.programId;
    this.name = config.name;
    this.displayName = config.displayName;
    this.active = config.active;
    this.duration = config.duration;
    this.expirationType = config.expirationType;
    this.price = config.price;
    this.oldDiscountType = config.oldDiscountType;
    this.gcEligible = config.gcEligible;
    this.availableOnline = config.availableOnline;
    this.haveGuest = config.haveGuest;
    this.gcRegCodeRowId = config.gcRegCodeRowId;
    this.ratingsRestricted = config.ratingsRestricted;
    this.taxable = config.taxable;
    this.renewalEligible = config.renewalEligible;
    this.displayOrder = config.displayOrder;
  }

  getName(): string | null {
    return this.displayName || this.name || null
  }

}
